import { fetchNodeConfig } from "../network/Network";

export const OutboundConfigReducer = (state, action) => {
  switch (action.type) {
    case "GET_STATION_CONFIG":
      const { dispatcher, baseUrl } = action.data;
      fetchNodeConfig(dispatcher, baseUrl);
      return state;
    case "RECEIVE_STATION_CONFIG":
      return { ...state, ...action.data };
    case "RECEIVE_REFRESH_INTERVAL":
      return {
        ...state,
        stationConfig: {
          ...state.stationConfig,
          refreshInterval: action.data.refreshInterval,
        },
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/components/outboundAmzl/reducers/OutboundConfigReducer.js